const EXTRACTING = Symbol('Extracting');
const LOADING_DRAFTS = Symbol('Loading drafts');

export const ExtractionStep = { EXTRACTING, LOADING_DRAFTS } as const;

export type ExtractionStep = (typeof ExtractionStep)[keyof typeof ExtractionStep];

export type ExtractionFailure = {
  error: Error;
  step: ExtractionStep;
};
